import apiClient from "services/axios";

const API = {
  info: "/api/v1/licenses/info",
  request: "/api/v1/licenses/request",
  assign: "/api/v1/licenses/assign",
};

export const info = async () => {
  const response = await apiClient.get(API.info);
  if (response) {
    return response.data;
  }
  return false;
};

export const requestKey = async () => {
  const response = await apiClient.get(API.request);
  if (response) {
    return response.data;
  }
  return false;
};

export const assignKey = async (body) => {
  const response = await apiClient.post(API.assign, body);
  if (response) {
    return response.data;
  }
  return false;
};
